import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const carousels = document.querySelectorAll(
    '.steps-carousel__carousel-wrapper'
  );

  if (0 < carousels.length) {
    carousels.forEach((carousel) => {
      new Swiper(carousel.querySelector('.steps-carousel__carousel'), {
        watchOverflow: true,
        slidesPerView: 1.1,
        spaceBetween: 10,

        breakpoints: {
          600: {
            slidesPerView: 2.2,
            spaceBetween: 10,
          },
          1080: {
            slidesPerView: 3.09,
            spaceBetween: 16,
          },
          1380: {
            slidesPerView: 'auto',
            spaceBetween: 16,
          },
        },

        navigation: {
          prevEl: carousel.querySelector('.swiper-button-prev'),
          nextEl: carousel.querySelector('.swiper-button-next'),
        },

        a11y: {
          slideRole: 'listitem',
          firstSlideMessage: _x(
            'This is the first element',
            'swiper label',
            'vtx'
          ),
          lastSlideMessage: _x(
            'This is the last element',
            'swiper label',
            'vtx'
          ),
          prevSlideMessage: _x('Previous element', 'swiper label', 'vtx'),
          nextSlideMessage: _x('Next element', 'swiper label', 'vtx'),
          slideLabelMessage: _x(
            'Element {{index}} of {{slidesLength}}',
            'swiper label',
            'vtx'
          ),
          paginationBulletMessage: _x(
            'Go to element {{index}}',
            'swiper label',
            'vtx'
          ),
        },
      });
    });
  }
});
